import { v4 as uuidv4 } from 'uuid';
import AccessTokenCookie from 'js/Services/Auth/Model/Identity/AccessTokenCookie.js';
import UserPerson from 'js/Services/Auth/Model/User/UserPerson.js';


class DAuth {

    constructor( authService ) {
        this.authService = authService;
        this.loginWithUserEmailPassword =  this.loginWithUserEmailPassword.bind(this);
        this.requestAccessToken =  this.requestAccessToken.bind(this);
        this.requestAuthorizationCodeByEmail =  this.requestAuthorizationCodeByEmail.bind(this);
    }

    async  loginWithUserEmailPassword( email , password ){
        const accessToken = await this.requestAccessToken(email , password);

        // const user = new UserPerson( accessToken.loggedInUser.id , accessToken.loggedInUser.firstname , accessToken.loggedInUser.lastname , accessToken.loggedInUser.email );
        // user.setManagingSuppliers(accessToken.loggedInUser.managingSuppliers );
        // const identity = new AccessTokenCookie( accessToken.token , user );

        const identity = accessToken;
        
        this.authService.setCurrentIdentity(identity);
        return identity;
    }

    async  fetchAccessTokenWithUserEmailPassword( email , password ){
        const accessToken = await this.requestAccessToken(email , password);
        return accessToken;
    }

    async  fetchAccessTokenWithAuthResults( authResults ){
        let response = await fetch(  '/rest-api/dauth/access_token'    ,
        {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json' ,
                'Accept': 'application/json'  ,
            },
            
            body : JSON.stringify({
                authResults : [...authResults]  ,
                type : 'AuthResult'
            }) ,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });

        if( response.status != 201 ){
            throw new Error('GeneralError');
        }

        const contentType = response.headers.get("Content-Type");
        if( !contentType || !contentType.trim ){
            throw new Error('NoContentTypeHeader');
        }

        if( contentType.trim().toLowerCase().indexOf('application/json') !== 0 ){
            throw new Error('JsonExpected');
        }
        return await response.json() ;
    }
 

    async requestAccessToken( email , password ){
        let response = await fetch(  '/rest-api/dauth/access_token'    ,
        {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json' ,
                'Accept': 'application/json'  ,
            },
            
            body : JSON.stringify({
                password : password  ,
                email : email  ,
                type : 'HashedPassword'
            }) ,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });

        if( response.status != 201 ){
            throw new Error('UserNamePasswordmatchError');
        }

        const contentType = response.headers.get("Content-Type");
        if( !contentType || !contentType.trim ){
            throw new Error('NoContentTypeHeader');
        }

        if( contentType.trim().toLowerCase() !=  'application/json'){
            throw new Error('JsonExpected');
        }
        return await response.json() ;
    }

    

    async requestAuthorizationCodeByEmail(email){
        let fetchResult = null;
        try {
            fetchResult = await fetch(  '/rest-api/dauth/authorization_code'    ,  {
               method: 'POST', // *GET, POST, PUT, DELETE, etc.
               mode: 'cors', // no-cors, *cors, same-origin
               cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
               credentials: 'same-origin', // include, *same-origin, omit
               headers: {
                   'Content-Type': 'application/json' ,
                   'Accept': 'application/json'  ,
               },
               body : JSON.stringify({
                   email : email 
               }) ,
               redirect: 'follow', // manual, *follow, error
               referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
           });
       } catch (error) {
           console.log('error' , error);
           throw error;
       }
       
       if( ! fetchResult?.status ){
           throw new Error('UserNamePasswordmatchError');
       }

       if( fetchResult.status != 201 ){
           throw new Error('UserNamePasswordmatchError');
       }

       const contentType = fetchResult.headers.get("Content-Type");
       if( !contentType || !contentType.trim ){
           throw new Error('NoContentTypeHeader');
       }

       if( contentType.trim().toLowerCase() !=  'application/json'){
           throw new Error('JsonExpected');
       }
       const AuthCodeJson = await fetchResult.json() ;

       return AuthCodeJson;
    }
}

const checkAccessTokenStatusOnServer = async ( token ) => {
    let fetchResult = null;
    try {
        fetchResult = await fetch(  '/rest-api/dauth-access-token/status/' + token    ,  {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json' ,
                'Accept': 'application/json'  ,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });
    } catch(e){
        throw new Error('ConnectionError');
    }
   
    if( ! fetchResult?.status ){
        throw new Error('ConnectionError');
    }

    if( fetchResult.status == 404 ){
        throw new Error('TokenNotFound');
    }

    if( fetchResult.status != 200 ){
        throw new Error('ConnectionError');
    }

    try {
        const json = await fetchResult.json();
        return json; 
    } catch (error) {
        throw new Error('Error');
    }
}
 

export default DAuth ;
export {checkAccessTokenStatusOnServer};